if (!window.$) {
  window.jQuery = window.$ = require('jquery');
}
